<template>
  <BaseModal
  :is-archivable="false"
  :is-editable="false"
  :is-visible="isPhoneModalVisible"
  :size="'lg'"
  @hideModal="hideModal()">
    <template #header>
      {{$t('buttons.addPhoneNote')}}
    </template>
    <template #body>
      <EXCMRelationForm
        :handle-submit="onSendForm"
        :handle-update-field="updateField"
        :values="item"
        :id-firm="idFirm"
        :id-case="idCase"
        :id-organization-lead="idOrganizationLead"
        :errors="violations"
        :initialDateTime="initialDateTime"
        :initialDuration="initialDuration"/>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import BaseModal from '@/components/BaseComponents/BaseModal'
import EXCMRelationForm from '../Form'
import CreateMixins from '@/components/Dashboard/Views/excmrelation/CreateMixins'

export default {
  name: 'PhoneCreateModal',
  components: {
    BaseModal,
    EXCMRelationForm
  },
  data () {
    return {
      item: {
        relationUserData: [],
        contactType: 2,
        idCategory: null
      }
    }
  },
  props: ['idCase', 'idFirm', 'idOrganizationLead', 'initialDateTime', 'initialDuration'],
  mixins: [CreateMixins],
  created () {
    if (this.idCase) {
      this.item.idCase = this.idCase
    }
  },
  watch: {
    isPhoneModalVisible () {
      this.item = {
        relationUserData: [],
        contactType: 2,
        idCategory: null
      }
    }
  },
  computed: {
    ...mapGetters({
      created: 'excmrelation/create/created',
      violations: 'excmrelation/create/violations',
      isPhoneModalVisible: 'excmrelation/createModal/getIsPhoneModalVisible'
    })
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleModal()
    },
    ...mapMutations({
      toggleModal: 'excmrelation/createModal/togglePhoneModal',
      setIsPhoneModalVisible: 'excmrelation/createModal/setIsPhoneModalVisible'
    }),
    ...mapActions({
      reset: 'excmrelation/create/reset',
      create: 'excmrelation/create/create'
    })
  }
}
</script>

<style scoped>

</style>
